import { useTranslation } from 'react-i18next';

import { DataPanelItem, DataPanelRow } from '@/ui';
import type { Position } from '@/signalr';
import { accuracyColor, formatAccuracy, formatAltitude } from '../../model/formatters';

export type PositionInfoPanelRowProps = {
  lastIncidentPosition: Position;
};

export function PositionInfoPanelRow({ lastIncidentPosition }: PositionInfoPanelRowProps) {
  const { t, i18n } = useTranslation();
  const language = i18n.language || 'en';

  return (
    <DataPanelRow>
      <DataPanelItem
        title={t('Incident_InfoPanel_Accuracy')}
        value={formatAccuracy(lastIncidentPosition.accuracy, language)}
        color={accuracyColor(lastIncidentPosition.accuracy)}
      />

      <DataPanelItem title={t('Incident_InfoPanel_Altitude')} value={formatAltitude(lastIncidentPosition, language)} />
    </DataPanelRow>
  );
}
